import { render, staticRenderFns } from "./system_version_list.vue?vue&type=template&id=ce12df20&scoped=true&"
import script from "./system_version_list.vue?vue&type=script&lang=js&"
export * from "./system_version_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce12df20",
  null
  
)

export default component.exports